import * as types from './mutations-types';

export default {
  [types.SET_ESTUDANTE](state, estudante) {
    state.estudante = estudante;
  },
  [types.SET_ESTUDANTES](state, estudantes) {
    state.estudantes = estudantes;
  },
  [types.SET_PAGINACAO](state, paginacao) {
    state.paginacao = paginacao;
  },
  [types.SET_ORDENACAO_BUSCA](state, ordenacaoBusca) {
    state.ordenacaoBusca = ordenacaoBusca;
  },
  [types.SET_UNIDADES](state, unidades) {
    state.formBusca.unidades = unidades;
  },
  [types.SET_MODALIDADES](state, modalidades) {
    state.formBusca.modalidades = modalidades;
  },
  [types.SET_CURSOS](state, cursos) {
    state.formBusca.cursos = cursos;
  },
  [types.SET_TURMAS](state, turmas) {
    state.formBusca.turmas = turmas;
  },
  [types.SET_VERSOES](state, versoes) {
    state.formBusca.versoes = versoes;
  },
  [types.SET_VARIAVEIS_SIMULACAO](state, variaveis) {
    state.variaveisSimulacao = variaveis;
  },
  [types.SET_ESTUDANTE_SIMULACAO](state, estudante) {
    state.estudanteSimulacao = estudante;
  },
  [types.SET_VARIAVEIS_IMPORTANCIA](state, variaveis) {
    state.variaveisImportancia = variaveis;
  },
  [types.SET_FORM_SIMULACAO](state, form) {
    state.formSimulacao = form;
  },
  [types.SET_VARIAVEIS_INFORMACOES](state, variaveis) {
    state.variaveisInformacoes = variaveis;
  },
  [types.SET_MODELO](state, modelo) {
    state.modelo = modelo;
  },
}



// WEBPACK FOOTER //
// ./src/pages/estudantes/store/mutations.js